
import React from 'react';
import { Container } from 'react-bootstrap';
import ImportantLinks from '../components/ImportantLinks';
import { User } from 'firebase/auth';

const Home = ({ currentUser }: { currentUser: User | null }) => {
  return (
    <div>
      <header className="hero-section text-center text-white" style={{ backgroundImage: 'url("https://i.postimg.cc/XvLWQwKV/Gemini-Generated-Image-phj7bpphj7bpphj7.png")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <Container>
          <h1 className="display-4">Welcome to Cashvax.in</h1>
          {currentUser && (
            <p className="lead">Welcome back, {currentUser.displayName || currentUser.email}!</p>
          )}
          <p className="lead">Your trusted partner in financial solutions.</p>
        </Container>
      </header>

      <section className="py-5">
        <Container>
          <p className="text-center fs-5">
            At Cashvax.in, we are dedicated to empowering individuals and businesses with the financial tools and knowledge they need to thrive in India's dynamic economic landscape. Our platform offers a comprehensive suite of resources, from intuitive calculators designed to simplify complex financial decisions like GST, income tax, and SIP planning, to a robust invoice generator that streamlines your billing processes. Beyond practical utilities, our blog provides insightful articles and expert analysis on crucial financial topics, helping you stay informed and make smarter choices. We believe that financial literacy is the cornerstone of prosperity, and our mission is to make sophisticated financial management accessible and understandable for everyone. Whether you're a budding entrepreneur, a seasoned professional, or simply looking to optimize your personal finances, Cashvax.in is your trusted partner on the journey to financial success. Explore our tools, delve into our knowledge base, and take control of your financial future today.
          </p>
        </Container>
      </section>

      <ImportantLinks />
    </div>
  );
};

export default Home;
